import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {};

export const contactIcon: SxStyle = {
  color: (p) => p.palette.success[800],
};

export const companyIcon: SxStyle = {
  color: (p) => p.palette.primary[500],
};
